import PropTypes from 'prop-types';
import React from 'react';
import {Box} from '@mui/material';
import {DateTime} from 'luxon';

import * as intervals from '@explorer/util/intervals';

const getMarkerLabel = (period, index, isDaily) => {
  if (
    period.interval === intervals.QUARTER ||
    period.interval === intervals.MONTH
  ) {
    const startYear = DateTime.fromISO(period.first_acquired, {
      zone: 'utc',
    }).year;
    const endYear = DateTime.fromISO(period.last_acquired, {zone: 'utc'}).year;

    if (startYear !== endYear || index === 1) {
      return endYear;
    }
  }

  if (period.interval === intervals.DAY || period.interval === intervals.WEEK) {
    const firstDate = DateTime.fromISO(period.first_acquired, {zone: 'utc'});
    const lastDate = DateTime.fromISO(period.last_acquired, {zone: 'utc'});
    const month = firstDate.month;

    const newDate = firstDate.plus({days: 1});

    if (newDate.month !== month || lastDate.month !== month) {
      let markerLabel = '';
      if (isDaily) {
        markerLabel = newDate.toFormat('MMM yyyy');
      } else {
        markerLabel = lastDate.toFormat('MMM yyyy');
      }

      return markerLabel;
    }
  }

  return '';
};

export const Marker = props => {
  const label = getMarkerLabel(props.period, props.index, props.isDaily);
  // don't render anything if there is no label.
  if (!label) {
    return false;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        flexShrink: 0,
        top: 'calc(50% - 6px)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          width: '1px',
          height: 8 * 2.75,
          bgcolor: 'grey.200',
        },
        '&:first-of-type': {
          marginLeft: 2.5,
        },
      }}
      left={props.index === 1 ? 0 : 'unset'}
    >
      <Box
        sx={{
          whiteSpace: 'nowrap',
          position: 'absolute',
          top: 8 * 3,
          transform: 'translateX(-50%)',
        }}
      >
        {label}
      </Box>
    </Box>
  );
};

Marker.propTypes = {
  period: PropTypes.object,
  index: PropTypes.number,
  isDaily: PropTypes.bool,
};
